import { render, staticRenderFns } from "./ReportXStudent.vue?vue&type=template&id=c69ba7fe"
import script from "./ReportXStudent.vue?vue&type=script&lang=js"
export * from "./ReportXStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports